import { useEffect, useRef } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { env } from "~/env";
import { ROUTES } from "~/router/constants";

declare global {
  interface Window {
    ours_consent?: {
      show: () => void;
      hide: () => void;
      isConsentModalVisible: () => boolean;
    };
  }
}

const OURS_CDN_URL = "https://cdn.oursprivacy.com";
const CONSENT_SCRIPT_ID = "ours-consent-script";

const BOOKING_ROUTES = [
  `${ROUTES.getStarted}/*`,
  ROUTES.schedulingDemographics,
  ROUTES.schedulingInitialVisit,
  ROUTES.schedulingEmailInput,
  ROUTES.schedulingPatientInformation,
  ROUTES.schedulingVisitConfirmed,
];

const isBookingRoute = (pathname: string) =>
  BOOKING_ROUTES.some((route) => matchPath(route, pathname));

const loadConsentBanner = (token: string) => {
  if (document.getElementById(CONSENT_SCRIPT_ID)) {
    return;
  }

  const stylesheet = document.createElement("link");
  stylesheet.rel = "stylesheet";
  stylesheet.href = `${OURS_CDN_URL}/consent.css`;

  const script = document.createElement("script");
  script.id = CONSENT_SCRIPT_ID;
  script.src = `${OURS_CDN_URL}/cmp-init?token=${encodeURIComponent(token)}`;

  document.head.append(stylesheet, script);
};

export const OursConsentBanner = () => {
  const { pathname } = useLocation();
  const isBooking = isBookingRoute(pathname);
  const hiddenOutsideBooking = useRef(false);

  useEffect(() => {
    const token = env.VITE_OURS_CONSENT_TOKEN;

    if (!token) {
      return;
    }

    if (isBooking) {
      loadConsentBanner(token);

      if (hiddenOutsideBooking.current) {
        hiddenOutsideBooking.current = false;
        window.ours_consent?.show();
      }

      return;
    }

    if (window.ours_consent?.isConsentModalVisible()) {
      hiddenOutsideBooking.current = true;
      window.ours_consent.hide();
    }
  }, [isBooking]);

  return null;
};
